import { render, staticRenderFns } from "./PageViewLayout.vue?vue&type=template&id=61440e1d&"
import script from "./PageViewLayout.vue?vue&type=script&lang=ts&"
export * from "./PageViewLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PageViewLayout.vue?vue&type=style&index=0&id=61440e1d&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports